<template lang="pug">
li.quick-action-button(
  v-show="areQuickActionsVisible !== null"
  @click="emitToggleQuickActions" 
  )
  button(type="button")
    BriqIcon(name="icon-menuquick" :customStyle="customStyle")
</template>

<script>
export default {
  name: 'QuickActionToggleButton',
  data() {
    return {
      areQuickActionsVisible: null,
    }
  },
  computed: {
    customStyle() {
      const fill = this.areQuickActionsVisible ? { fill: '#009bff' } : {}
      return { ...fill, transition: 'fill 0.2s ease' }
    },
  },
  methods: {
    emitToggleQuickActions() {
      this.$bus.$emit('toggleQuickActions')
    },
  },
  mounted() {
    this.$bus.$on('showQuickActions', areQuickActionsVisible => {
      this.areQuickActionsVisible = areQuickActionsVisible
    })
  },
}
</script>

<style scoped lang="stylus">
.quick-action-button
  button
    outline 0

  .icon
    font-size 12px
    fill #fff
    display block
</style>
